module.exports = __webpack_public_path__ + "static/media/87.f8e740c.wav";


//////////////////
// WEBPACK FOOTER
// ./src/assets/audio/87.wav
// module id = IlhY
// module chunks = 0